import { render, staticRenderFns } from "./IP_RebuttalsTrackingByCoder.vue?vue&type=template&id=fd8b4898&scoped=true&"
import script from "./IP_RebuttalsTrackingByCoder.vue?vue&type=script&lang=js&"
export * from "./IP_RebuttalsTrackingByCoder.vue?vue&type=script&lang=js&"
import style0 from "./IP_RebuttalsTrackingByCoder.vue?vue&type=style&index=0&id=fd8b4898&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd8b4898",
  null
  
)

export default component.exports